<template>
  <div class="learner_feeds">

    <!-- Milestones -->
    <div class="row long_row milestone" v-if="isMilestonesEnabled() && showCertificateTracker">
      <div class="col-12">
        <div class="card ace_sec crd_cal">
          <div class="card-header">
            <div class="hd_ic">
              <span class="ic ic26-milestone"></span>
            </div>
            <div class="hd_txt ace_sec_hd">
              {{getMilestonesLabel()}}
            </div>
          </div>
          <div class="card-body">
            <div class="row quick_link">
              <template v-for="(milestone, i) in currentProgram.children" >
                <div class="col-2">
                  <div class="progress-row" :title="milestone.description">
                    <div class="progress-bar-label ace_sec_txt" :aria-label="milestone.title">
                      {{milestone.title}}
                    </div>
                    <b-progress :max="milestone.total">
                      <b-progress-bar :value="milestone.completed" class="prog_bar__completed">
                      </b-progress-bar>
                      <b-progress-bar :value="milestone.inProgress" class="prog_bar__in_progress">
                      </b-progress-bar>
                    </b-progress>
                  </div>
                </div>
                <div class="steps_sep" v-if="i<currentProgram.children.length-1">
                  <span class="ic ic26-arr_next"></span>
                  <span class="ic ic26-arr_next"></span>
                </div>
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- End Milestones  -->

    <!-- Quick Links -->
    <div class="row long_row recommended_msg_row" v-if="links.length>0">
      <div class="col-12">

        <div class="card ace_sec crd_cal">
          <div class="card-body">

            <div class="row quick_link">
              <div class="col-2 row_icon">
                <div class="icon ic24-link">
                </div>
              </div>
              <div class="col-12 row_detail">
                <div class="row cal_detail">
                  <div class="col-12 block_row row_title ace_sec">
                    <span class="label">{{getQuickLinksLabel()}} </span>
                  </div>
                  <div class="col-12 block_row ace_sec" v-for="(link, i) in links" >
                    <b-link @click="launchQuickLink(link.url)" v-if="i<showLinkSize">{{link.title}}</b-link>
                  </div>
                </div>
                <div class="row lnk_container">
                  <div class="col-12 lnk_container ace_sec">
                    <b-link @click="showAllLink" v-if="links.length > showLinkSize">{{links.length-showLinkSize}} more {{getQuickLinksLabel()}}</b-link>
                    <b-link @click="showLimitedLink" v-if="showLinkSize>2 && links.length <= showLinkSize">show limited {{getQuickLinksLabel()}}</b-link>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>

      </div>
    </div>
    <!-- End Quick Links  -->
    <!-- Recommendation Event -->
    <div class="row long_row recommended_msg_row" v-if="lastRecommendedMessage">
      <div class="col-12">

        <div class="card ace_sec crd_cal">
          <div class="card-body">

            <div class="row">
              <div class="col-2 row_icon">
                <div class="icon fas fa-user">
                </div>
              </div>
              <div class="col-12 row_detail">
                <div class="row cal_detail">
                  <div class="col-12 block_row row_title ace_sec">
                    <span class="label">{{lastRecommendedMessage.message.name}}</span>
                  </div>
                  <div class="col-12 block_row ace_sec" v-html="lastRecommendedMessage.message.text">
                  </div>
                </div>
                <div class="row lnk_container" v-if="unreadCountState>1">
                  <div class="col-12 lnk_container ace_sec">
                    <b-link @click="navigateToChannel">{{unreadCountState}} unread messages</b-link>
                  </div>
                </div>
                <div class="row lnk_container" v-if="unreadCountState==1">
                  <div class="col-12 lnk_container ace_sec">
                    <b-link @click="navigateToChannel">
                      {{ $tf('readMsg') }}
                    </b-link>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>

      </div>
    </div>
    <!-- Recommendation Event -->

    <!-- Calendar Events -->
    <div class="row long_row" v-if="nextCalendarEvents.length > 0">
      <div class="col-12">

        <div class="card ace_sec crd_cal">
          <div class="card-body">
            <div class="row">
              <div class="col-2 row_icon">
                <div class="ic ic22-dateRange">
                </div>
              </div>
              <div class="col-12 row_detail">
                <div class="row cal_detail">
                  <div class="col-12">
                    <div class="row">
                      <div class="col-12 block_row row_title">
                        {{nextCalendarEvents[0].title}}
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-5 block_row">
                        <span class="label">When:</span> {{nextCalendarEvents[0].formattedStartDateTime}}
                      </div>
                      <div class="col-5 block_row">
                        <span class="label">Where:</span> {{nextCalendarEvents[0].location}}
                      </div>
                      <div class="col-2 lnk_container">
                        <b-link :to="{name: 'calendarEventList'}">more events</b-link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
    <!-- Calendar Events Ends -->

    <!-- Feeds  -->
    <div class="row long_row" v-for="(feed, i) in feeds">
      <div class="col-12">

        <div class="card ace_sec crd_cal">
          <div class="card-body">
            <div class="row">
              <div class="col-2 row_icon" v-if="feed.iconUrl">
                  <img v-bind:src="feed.iconUrl" width="70" height="70">
              </div>
              <div class="col-2 row_icon" v-else>
                <div class="ic ic22-club">
                </div>
              </div>
              <div class="col-12 row_detail">
                <div class="row cal_detail">
                  <div class="col-12">
                    <div class="row">
                      <div class="col-12 block_row row_title">
                        {{feed.title}}
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-12 block_row row_desc" v-if="feed.description" v-html="trimDesc(feed.description)">
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-5 block_row" >
<!--                        <span class="label" v-if="feed.startDate">When:</span> {{feed.startDate}} -->
                      </div>
                      <div class="col-5 block_row">
                        <span class="label" v-if="feed.address" >Where:</span> {{feed.address}}
                      </div>
                      <div class="col-2 lnk_container">
                        <b-link @click="launch(feed)" v-if="feed.entityType==='PATHWAY' ">explore pathway</b-link>
                        <b-link @click="launch(feed)" v-else-if="feed.entityType==='EXPLORE' ">explore careers</b-link>
                        <b-link @click="launch(feed)" v-else-if="feed.entityType==='EXPLORE_JOBS' ">explore jobs</b-link>
                        <b-link @click="launch(feed)" v-else-if="feed.entityType==='EXPLORE_EMPLOYER_JOB' ">explore jobs</b-link>
                        <b-link @click="launch(feed)" v-else-if="feed.entityType==='EXPLORE_PROGRAM' ">explore programs</b-link>
                        <b-link @click="launch(feed)" v-else>more detail</b-link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
    <!-- Feeds Ends -->

  </div>
</template>

<script>
  import { mapState, mapActions } from 'vuex'
  import { db, storage } from '../../../firebase'
  export default {
    name: 'learner-feeds',
    data: () => {
      return {
        nextCalendarEvents: [],
        messages: [],
        recommendations: [],
        test: {},
        moreRecommendations : 0,
        feeds: [],
        showLinkSize : 2,
        currentProgram : {}
      }
    },
    mounted () {
      setTimeout(() => {
            this.loadLearnerFeed()
          }, 1000)
      this.loadQuickLinks('QUICKLINK')

    },

    beforeMount () {
      this.$root.$on('reloadCompetencyProgress', (data) => {
        this.populateProgram(data)
      })
      this.$root.$on('reloadLearnerDashboard', () => {
        this.loadLearnerFeed()
      })

    },

    methods: {
      ...mapActions([
        'loadGetNextCalendarEvent',
        'loadFeedsForStudent',
        'loadRecommendationsForStudent',
        'loadQuickLinks',
        'loadProgramTracking',
        'loadAllChannels'
      ]),
      async populateProgram (data) {
          this.currentProgram = await this.loadProgramTracking(data.programCode)
      },

      async loadLearnerFeed () {
        this.nextCalendarEvents = await this.loadGetNextCalendarEvent()
        this.recommendations = await this.loadRecommendationsForStudent()
        await this.loadAllChannels()
        this.feeds = await this.loadFeedsForStudent()
      },
      navigateToChannel () {
        return this.$router.push({name: 'courseSectionChannel', params: {uuid: this.userObj.uuid, selectedCurrentChannel: this.lastRecommendedMessage.channel, channelType: 'ALL', isShowBack: false}})
      },
      showAllLink() {
        this.showLinkSize = this.links.length
      },
      showLimitedLink () {
        this.showLinkSize = 2
      },
      trimDesc (desc){
        if(desc && desc.length>315){
            desc = desc.substring(0,315)
            let lastSpace = desc.lastIndexOf(" ")
            desc = desc.substring(0,lastSpace)
            desc += " ..."
        }
        return desc
      },
      isMilestonesEnabled () {
          return this.isFlagEnabled('learner_dashboard', 'Show Milestones')
      },
      getMilestonesLabel (){
          return this.getFlagLabel('learner_dashboard', 'Show Milestones', 'Milestones')
      },
      isCategorizedProgressEnabled () {
          return this.isFlagEnabled('learner_dashboard', 'Show Categorized Progress')
      },
      isFinancialInformationEnabled () {
          return this.isFlagEnabled('learner_dashboard', 'Show Financial Information')
      },

      isFlagEnabled (featureId, flagValue) {
        let learnerDB = this.enabledFeatures[featureId]
        if (learnerDB && learnerDB.enabled) {
          let flags = learnerDB.flags
          for (var i = 0; i < flags.length; i++) {
            if (flags[i].title === flagValue) {
              return flags[i].enabled
            }
          }
        }
        return false;
      },
      getFlagLabel (featureId, flagValue, defaultLabel) {
        let learnerDB = this.enabledFeatures[featureId]
        if (learnerDB && learnerDB.enabled) {
          let flags = learnerDB.flags
          for (var i = 0; i < flags.length; i++) {
            if (flags[i].title === flagValue) {
              return flags[i].label
            }
          }
        }
        return defaultLabel;
      },
      getQuickLinksLabel () {
        let quickLinks = this.enabledFeatures['quick_links']
        return quickLinks && quickLinks.label ? quickLinks.label : this.$tf('quickLinks', 'Quick Links')
      },
      launchQuickLink(url){
        window.open(url, '_blank')
      },
      launch (feed){
        if(feed.entityType ==='event' && feed.url){
          window.open(feed.url, '_blank')
        }
        if(feed.entityType !=='event' && feed.url){
          this.$router.push(feed.url)
        }

      }
    },
    computed: {
      ...mapState({
        'userObj': state => state.user.userObj,
        'enabledFeatures': state => state.institution.enabledFeatures,
        'links': state => state.dashboard.quickLinks,
        'unreadCountState': state => state.channel.unreadCountState
      }),
      showCertificateTracker (){
        return this.currentProgram.trackCertificate
      },
      lastRecommendedMessage () {
        if (this.recommendations) {
          for (const [key, value] of Object.entries(this.recommendations)) {
            let messages = this.recommendations[key]
            if (messages.length > 0) {
            this.moreRecommendations = messages.length-1
              return {
                'channel': key,
                'message': messages[0]
              }
            }
          }
        }
        return null
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/app/dashboard/components/LearnerFeeds.vue